<template>
<div class="chapter">
<div class="inner_page">
<p class="fhd1"><a id="page_2"></a>Enthusiastic Praise for</p>
<p class="fhd2">BARBARA DELINSKY</p>
<p class="fpara">“One of today’s quintessential authors of contemporary fiction … Ms. Delinsky is a joy to read. With the incisive skill of a surgeon and the delicate insight of true compassion, she deeply probes the quality and meaning of life. Women’s fiction at its very finest.”</p>
<p class="fright">—<em class="italic">Romantic Times</em></p>
<p class="fpara">“[An author] of sensitivity and style.”</p>
<p class="fright">—<em class="italic">Publishers Weekly</em></p>
<p class="fpara">“Ms. Delinsky has a special knack for zeroing in on the pulse of her characters immediately—we know them and understand what makes them tick within the first few pages…. Well done!”</p>
<p class="fright">—<em class="italic">Rendezvous</em></p>
<p class="fpara">“When you care enough to read the very best, the name of Barbara Delinsky should come immediately to mind…. One of the few writers … who still writes a great love story, Ms. Delinsky is truly an author for all seasons.”</p>
<p class="fright">—<em class="italic">Rave Reviews</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Front1.vue?67e8524c